import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "core-js/features/promise/all-settled";
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.scss";
import App from "./App";
import "./i18n";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);
